module.exports = {"item":[{"code":"SCHOOL","title":"学校管理","icon":"ti-pencil-alt","item":[{"code":"SCHOOL_TEACHER","title":"教师列表","url":"/teacher/teacherList"}]},{"code":"SALARY_SLIP","title":"工资管理","icon":"ti-money","item":[{"code":"SCHOOL_SALARY_SLIP_LIST","title":"工资列表","url":"/salary/SalarySlipList"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/menu_school.json
// module id = 90
// module chunks = 2